import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { Box, IconButton, Stack, Typography } from "@mui/material"
import { useSelector } from "react-redux"
import type { RootState } from "@/store"

interface ScreenHeaderProps {
    title: string
    subTitle: string
    onClickBack?: () => void
    voltarDesabilitado?: boolean
    logoUrl?: string | null
    alturaLogo?: number
    fonteTitulo?: string
    fonteSubtitulo?: string
}

function ScreenHeader({ title, subTitle, onClickBack, voltarDesabilitado = false, logoUrl: logoDaProp, alturaLogo = 64, fonteTitulo, fonteSubtitulo }: ScreenHeaderProps): any {
    const logoDoCheckout = useSelector((state: RootState) => state.selfServiceKiosk.logoUrl)
    const logoUrl = logoDaProp !== undefined ? logoDaProp : logoDoCheckout

    return (
        <Stack
            direction="row"
            sx={{
                p: 2,
                pb: 1.5,
                width: '100%',
                flexShrink: 0,
                alignItems: 'center',
                justifyContent: 'space-between',
                borderBottom: '1px solid',
                borderColor: 'divider'
            }}
        >
            <Stack direction="row" sx={{ alignItems: 'center' }}>
                {onClickBack && (
                    <IconButton
                        onClick={onClickBack}
                        disabled={voltarDesabilitado}
                        aria-label="Voltar"
                        sx={{ border: '1px solid', borderRadius: 2, minWidth: 48, minHeight: 48 }}
                    >
                        <ArrowBackIcon />
                    </IconButton>
                )}

                <Stack direction="column" sx={{ ml: onClickBack ? 1.5 : 0 }}>
                    <Typography variant="h4" sx={{ fontWeight: 'bold', fontSize: fonteTitulo }}>
                        {title}
                    </Typography>

                    <Typography variant="h6" color="text.secondary" sx={{ fontSize: fonteSubtitulo }}>
                        {subTitle}
                    </Typography>
                </Stack>
            </Stack>

            <Stack>
                {logoUrl && (
                    <Box
                        component="img"
                        src={logoUrl}
                        alt="Logo da loja"
                        sx={{ maxHeight: alturaLogo, objectFit: 'contain', flexShrink: 0 }}
                    />
                )}
            </Stack>
        </Stack>
    )
}

export default ScreenHeader